/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Product Offerings Sagas for select MegaPowers step
 *
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.27.0
 */

import styled from 'styled-components';

export const ModalMultipleOrdersStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const ModalMultipleOrdersTextContainer = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;

    & > span:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const ModalMultipleOrdersButtonsContainer = styled.div`
    display: flex;
    margin-top: 32px;
    margin-bottom: 8px;

    & > button:not(:last-child) {
        margin-right: 16px;
    }
`;
